module.exports = __webpack_public_path__ + "static/media/google.36982f01.png";